import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import { Layout } from "@/components/site/Layout";
import Home from "@/pages/Home";
import Intelligence from "@/pages/Intelligence";
import ThemeDetail from "@/pages/ThemeDetail";
import Locations from "@/pages/Locations";
import LocationDetail from "@/pages/LocationDetail";
import Journal from "@/pages/Journal";
import Article from "@/pages/Article";
import LandAndLaw from "@/pages/LandAndLaw";
import Advisory from "@/pages/Advisory";
import About from "@/pages/About";
import PersonProfile from "@/pages/PersonProfile";
import Guided from "@/pages/Guided";
import DocumentIntake from "@/pages/DocumentIntake";
import Privacy from "@/pages/Privacy";
import NotFound from "@/pages/NotFound";
import BrandReview from "@/pages/BrandReview";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/brand" element={<BrandReview />} />
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/intelligence" element={<Intelligence />} />
          <Route path="/intelligence/:slug" element={<ThemeDetail />} />
          <Route path="/locations" element={<Locations />} />
          <Route path="/locations/:slug" element={<LocationDetail />} />
          <Route path="/journal" element={<Journal />} />
          <Route path="/journal/:slug" element={<Article />} />
          <Route path="/land-and-law" element={<LandAndLaw />} />
          <Route path="/advisory" element={<Advisory />} />
          <Route path="/about" element={<About />} />
          <Route path="/suhail-abbas-zaidi" element={<PersonProfile personKey="suhail" />} />
          <Route path="/vibhor-nautiyal" element={<PersonProfile personKey="vibhor" />} />
          <Route path="/guided" element={<Guided />} />
          <Route path="/buyer-assistance" element={<Guided />} />
          <Route path="/buyer-assistance/documents" element={<DocumentIntake />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
      <Toaster position="bottom-right" />
    </BrowserRouter>
  );
}

export default App;
